import { useState } from "react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { fmtDateTime } from "@/lib/api";

export const OrderThread = ({ messages = [], me, onSend }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    await onSend(text);
    setText("");
    setBusy(false);
  };
  return (
    <div data-testid="order-thread" className="space-y-3">
      <div className="max-h-72 space-y-2 overflow-y-auto">
        {messages.length === 0 && <p className="text-sm text-gray-500">Aucun message pour cette commande.</p>}
        {messages.map((m, i) => (
          <div key={i} className={`max-w-[85%] rounded-xl px-3 py-2 text-sm ${m.from === me ? "ml-auto bg-orange-500 text-white" : "bg-gray-100 text-gray-800"}`}>
            <p className="text-[11px] font-semibold opacity-80">{m.name} · {fmtDateTime(m.at)}</p>
            <p className="whitespace-pre-wrap">{m.text}</p>
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <Textarea data-testid="order-message-input" rows={2} value={text} onChange={(e) => setText(e.target.value)} placeholder="Écrire un message concernant cette commande…" />
        <Button data-testid="order-message-send" onClick={send} disabled={busy} className="self-end"><Send className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};
